<template>
  <Admin style="background: white">
    <v-main v-if="!isProductListLoading" class="wrapper">
      <!-- Conditional Message if Feature is Not Available -->
      <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank">
          <b><u>026637895</u></b>
        </a>
      </v-container>

      <!-- Main Content with Inputs and Buttons -->

      <v-container v-else fluid>
        <div class="mb-1 tw-text-xl tw-font-bold tw-mb-3">
          รายงานภาษีมูลค่าเพิ่ม
        </div>
        <v-row justify="center" style="margin-bottom: 20px;">
          <v-col>
            <v-card id="table-firebase">
              <v-container fluid class="tw-p-4 tw-min-h-70">
                <div
                  class="input-group tw-grid tw-grid-cols-2 tw-gap-8 tw-max-w-5xl"
                >
                  <!-- Left Column -->
                  <div
                    class="left-col tw-gap-4 tw-grid tw-grid-cols-1 tw-items-center tw-mt-1"
                  >
                    <!-- Row 1: Tax Type Selection -->
                    <div
                      class="tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
                    >
                      <div >ประเภทภาษีมูลค่าเพิ่ม</div>
                      <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedTaxType"
                        label="เลือกประเภทภาษี"
                        :items="TaxTypeList"
                        outlined
                        dense
                        hide-details
                        style="max-width: 280px;"
                      ></v-select>
                    </div>

                    <!-- Row 3: Branch Selection -->
                    <div
                      class="tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
                    >
                      <div >สาขากิจการ</div>
                      <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedBranch"
                        label="เลือกสาขากิจการ"
                        :items="taxWHBranch.branch"
                        item-text="code"
                        item-value="code"
                        outlined
                        dense
                        hide-details
                        style="max-width: 280px;"
                      ></v-select>
                    </div>

                    <!-- Row 4: Tax Period Selection -->
                    <div
                      class="tw-grid tw-grid-cols-2 tw-items-center tw-gap-3"
                    >
                      <div >Tax Period</div>
                      <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                        v-model="selectedPeriod"
                        :items="hierarchicalPeriods"
                        label="เลือก Tax Period"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        ref="selectMenu"
                        return-object
                        hide-details
                        style="max-width: 280px;"
                      >
                      <template v-slot:item="{ item, props }">
                          <v-list-item
                            v-bind="props"
                            :class="getColorClass(item)"
                            :disabled="item.level === 0 || item.level === 1"
                            @click="handleSelectionAndCloseMenu(item)"
                          >
                            <v-list-item-title
                              :style="{
                                fontWeight:
                                  item.level === 0 ? 'bold' : 'normal',
                              }"
                            >
                              <span
                                :style="{
                                  paddingLeft: `${item.level * 20}px`,
                                  opacity: 1,
                                  color: item.level === 0 ? '#1976D2' : 'black',
                                  fontWeight:
                                    item.level === 0 ? 'bold' : 'normal',
                                }"
                              >
                                {{ item.name }}
                              </span>
                            </v-list-item-title>
                          </v-list-item>
                        </template>
                      </v-select>
                    </div>

                    <!-- Buttons for Generating Reports -->
                    <div
                      class="tw-grid tw-grid-cols-2 tw-gap-3 tw-items-center place-items-center"
                    >
                      <div class="tw-flex tw-justify-end">
                        <v-btn
                          color="primary"
                          @click="onClickPDF(selectedTaxWHCode)"
                          block
                        >
                          <v-icon left>mdi-printer</v-icon>
                          | ออกรายงานภาษี (PDF)
                        </v-btn>
                      </div>
                      <div>
                        <v-btn
                          color="primary"
                          @click="onClickExcel(selectedTaxWHCode)"
                          block
                        >
                          <v-icon left>mdi-printer</v-icon>
                          | ออกรายงานภาษี (Excel)
                        </v-btn>
                      </div>
                    </div>
                  </div>

                  <!-- Left Column -->
                  <div
                    class="left-col tw-gap-4 tw-grid tw-grid-cols-1 tw-grid-rows-5 tw-items-start"
                  >
                    <div
                      class="tw-grid tw-row-start-1 tw-row-span-4 
                      tw-h-full tw-items-center tw-gap-3"
                    >
                      <div class="tw-flex tw-gap-4 tw-h-full ">
                        <div  class="tw-col-auto tw-pt-3">
                          รหัสภาษีมูลค่าเพิ่ม
                        </div>
                        <div
                          class="tw-overflow-y-scroll tw-h-full hide-scroll-bar tw-justify-center tw-flex tw-flex-col"
                          style="
                            border-radius: 10px !important;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                            border-radius: 4px;
                            padding: 8px;
                          "
                        >
                          <v-checkbox
                            v-for="(taxCode, index) in taxCodes"
                            :key="index"
                            :label="`${taxCode.code} : ${taxCode.description}`"
                            :value="taxCode.code"
                            v-model="selectedTaxCodes"
                            hide-details
                            dense
                            style="
                              max-width: 280px;
                              border-radius: 10px !important;
                            "
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
            <!-- Snackbar Notification for User Feedback -->
            <v-snackbar
              v-model="snackbar"
              top
              :color="snackbarColor"
              timeout="2000"
              class="tw-text-center"
            >
              {{ snackbarText }}
            </v-snackbar>
          </v-col>
        </v-row>
      </v-container>
      <!-- แสดงตัวอย่าง PDF -->
      <v-dialog v-model="pdfDialog" max-width="1100px" max-height="600px">
        <iframe
          v-if="pdfSrc"
          :src="pdfSrc"
          width="100%"
          height="800px"
          frameborder="0"
        ></iframe>
        <v-alert v-else type="error" color="red"> Failed to load PDF. </v-alert>
      </v-dialog>
    </v-main>
  </Admin>
</template>

<style scoped>
.checkbox-container {
  max-height: 160px;
  overflow-y: auto;
  max-width: 280px;
}

/* Custom CSS for Compact Row Spacing */
.compact-row {
  margin-bottom: 8px;
  /* Adjust this value for tighter or looser spacing */
}
.hide-scroll-bar {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.hide-scroll-bar::-webkit-scrollbar {
  /* WebKit */
  width: 0;
  height: 0;
}
</style>

<script>
import Admin from "@/components/admin/admin-main-template";
import isMobile from "../../libs/detectMobile";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import "firebase/auth";
import { mapState } from "vuex";
import {
  getHierarchicalPeriods,
  getCurrentPeriodMonth,
} from "@/libs/getPerioid";
const _ = require("lodash");
const axios = require("axios");
const moment = require("moment");
const periods = getHierarchicalPeriods(2023, new Date().getFullYear());
const currentPeriod = getCurrentPeriodMonth(periods);

export default {
  data() {
    return {
      selectedPeriod: currentPeriod,

      taxWHCode: [
        { code: "2", description: "ภ.ง.ด.3", active: false },
        { code: "1", description: "ภ.ง.ด.53", active: true },
      ],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      years: [2023, 2024, 2025],
      taxPeriods: [],

      companyID: this.$route.params.companyId,

      selectedTaxWHCode: "1",

      selectedStartDate: null,
      selectedEndDate: null,
      downloadPdfLoading: false,
      pdfDialog: false,
      pdfSrc: "",
      searchData: null,
      isExporting: false,
      attachSheetPage: 6,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      isSmallScreen: false,

      //
      TaxTypeList: ["ภาษีขาย", "ภาษีซื้อ"],

      selectedTaxType: "ภาษีขาย",
      selectedTaxCodes: [],
      selectedBranch: null,
      selectedTaxPeriod: "",
    };
  },
  name: "TaxReport",
  components: {
    Admin,
  },
  created() {
    this.getTimePeriods();
    this.getTaxWHBranch();
    // this.getCompanyDetail();
    this.$store.dispatch("thaismartTaxDetail/getTaxCodes", {
      companyId: this.$route.params.companyId,
    });
  },
  mounted() {
    this.updateScreenSize();
    window.addEventListener("resize", this.updateScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
  methods: {
    updateScreenSize() {
      this.isSmallScreen = window.innerWidth < 600;
    },
    getColorClass(item) {
      if (item.type === 'quarter') {
        return 'bg-quarter'; 
      } else if (item.type === 'year') {
        return ''; 
      }
      return '';
    },
    handleSelection(item) {
      if (item) {
        this.selectedStartDate = item.startDate;
        this.selectedEndDate = item.endDate;
        console.log("Selected period:", item.name);
        console.log(
          "Selected start date:",
          this.getDateWithFormat(this.selectedStartDate)
        );
        console.log(
          "Selected end date:",
          this.getDateWithFormat(this.selectedEndDate)
        );
      }
    },
    onBranchSelect(branch) {
      if (branch) {
        this.selectedBranch = branch;
      }
    },
    getDateWithFormat(timestamp) {
      if (!timestamp) return;
      // Convert Firebase timestamp to milliseconds
      const seconds = timestamp._seconds || timestamp.seconds || 0;
      const nanoseconds = timestamp._nanoseconds || timestamp.nanoseconds || 0;

      // Convert the timestamp to milliseconds
      const milliseconds = seconds * 1000 + Math.floor(nanoseconds / 1000000);

      // Create a JavaScript Date object from milliseconds
      const date = new Date(milliseconds);

      const parsedDate = moment(date);

      const date_pay = parsedDate.format("D");

      const month_pay = parsedDate.format("MMMM");

      const year_pay = parsedDate.format("YYYY");
      const time_pay = parsedDate.format("HH:mm:ss");

      return `${date_pay}-${month_pay}-${year_pay} ${time_pay}`;
    },

    handleSelectionAndCloseMenu(period) {
      this.selectedPeriod = period;
      // this.handleSelection(item);
      this.$refs.selectMenu.blur();
    },
    onClickPDF: async function (selectedTaxWHCode) {
      try {
        // Check if the required fields are provided
        if (!this.selectedPeriod) {
          throw new Error("Please select Periods before exporting.");
        }
        if (this.selectedTaxCodes.length === 0) {
          throw new Error("Please select TaxCodes before exporting.");
        }
        this.$store.dispatch("setGlobalLoading", true);
        if (this.downloadPdfLoading) return;
        this.downloadPdfLoading = true;
        this.pdfSrc = null;

        // Validate the selected tax code
        if (!["1", "2"].includes(selectedTaxWHCode)) {
          throw new Error("Invalid tax code selected");
        }

        // get user token
        let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function (idToken) {
            return idToken;
          });
        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        const requestData = {
          companyID: this.$route.params.companyId,
          type: selectedTaxWHCode,
          data: {
            taxType: this.selectedTaxType,
            taxCodes: this.selectedTaxCodes,
            branch: this.selectedBranch,
            period: this.selectedPeriod,
          },
        };
        // console.log("requestData", requestData);

        // Make the POST request to generate the PDF
        const response = await axios
          .post(fc.cloudFunctionUrl + "generateTaxReportPdf", requestData, { headers, responseType: "arraybuffer" })
          // .post(
          //   "http://localhost:5001/sld-etax/us-central1/generateTaxReportPdf",
          //   requestData,
          //   { headers, responseType: "arraybuffer" } // Receive as binary data
          // );

        if (response.status === 200) {
          // Convert the file buffer to a Blob URL
          const blob = new Blob([response.data], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(blob);

          // Show the PDF in the popup (pdfDialog)
          this.pdfSrc = pdfUrl;
          this.pdfDialog = true;
        } else {
          throw new Error("Failed to generate PDF");
        }
      } catch (error) {
        const errorMessage =
          error.response?.status === 404
            ? error.response.data.error || "Document not found."
            : error.message;

        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = errorMessage;
      } finally {
        // Reset loading states
        this.downloadPdfLoading = false;
        // this.selectedPeriod = null;
        // this.selectedStartDate = null;
        // this.selectedEndDate = null;
        this.$store.dispatch("setGlobalLoading", false);
      }
    },
    onClickExcel: async function (selectedTaxWHCode) {
      try {

        if (!this.selectedPeriod) {
          throw new Error("Please select Periods before exporting.");
        }
        if (this.selectedTaxCodes.length === 0) {
          throw new Error("Please select TaxCodes before exporting.");
        }

        this.$store.dispatch("setGlobalLoading", true);
        if (this.downloadPdfLoading) return;
        this.downloadPdfLoading = true;

        if (!["1", "2"].includes(selectedTaxWHCode)) {
          throw new Error("Invalid tax code selected");
        }

        // get user token
        let token = await firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ false)
          .then(function (idToken) {
            return idToken;
          });
        const headers = {
          "Content-Type": "application/json",
          Authorization: "JWT " + token,
        };

        const requestData = {
          companyID: this.$route.params.companyId,
          type: selectedTaxWHCode,
          data: {
            taxType: this.selectedTaxType,
            taxCodes: this.selectedTaxCodes,
            branch: this.selectedBranch,
            period: this.selectedPeriod,
          },
        };
        // console.log("requestData", requestData);

        // Make the POST request to generate the Excel
        const response = await axios
          .post(fc.cloudFunctionUrl + "generateTaxReportExcel", requestData, { headers, responseType: "arraybuffer" })
          // .post(
          //   "http://localhost:5001/sld-etax/us-central1/generateTaxReportExcel",
          //   requestData,
          //   { headers, responseType: "arraybuffer" } // รับข้อมูลเป็น binary
          // );

        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const excelUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = excelUrl;
          link.setAttribute("download", "TaxReport.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          throw new Error("Failed to generate Excel");
        }
      } catch (error) {
        const errorMessage =
          error.response?.status === 404
            ? error.response.data.error || "Document not found."
            : error.message;

        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbarText = errorMessage;
      } finally {
        // Reset loading states
        this.downloadPdfLoading = false;
        // this.selectedPeriod = null;
        // this.selectedStartDate = null;
        // this.selectedEndDate = null;
        this.$store.dispatch("setGlobalLoading", false);
      }
    },
    getTimePeriods: function () {
      let companyId = this.$route.params.companyId;
      let year = new Date().getFullYear();
      if (companyId) {
        this.$store.dispatch("thaismartTax/fetchTimePeriods", {
          companyId: companyId,
          year: year,
        });
      }
    },
    getTaxWHBranch: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store
          .dispatch("thaismartTax/fetchTaxWHBranch", { companyId: companyId })
          .then(() => {
            this.selectedBranch = this.taxWHBranch?.branch[0].code || null;
          })
          .catch((error) => {
            console.error("Error fetching branches:", error);
          });
      }
    },
    getCompanyDetail: function () {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("companies/getCompany", {
          companyID: companyId,
        });
      }
    },
    getDocsThaiSm: function () {
      return new Promise((resolve, reject) => {
        let companyId = this.$route.params.companyId;
        if (!companyId) {
          reject(new Error("Company ID is not available"));
          return;
        }

        this.$store
          .dispatch("thaismartTax/fetchDocsThaiSm", {
            companyId: companyId,
            taxWHCode: this.selectedTaxWHCode,
            startDate: this.selectedStartDate,
            endDate: this.selectedEndDate,
            subsidiariesBranch: this.selectedBranch.code,
          })
          .then(() => {
            if (this.docsThaiSm && this.docsThaiSm.length > 0) {
              resolve(this.docsThaiSm);
            } else {
              reject(
                new Error(
                  "Oops! We couldn't find any results for your search. Please try different criteria."
                )
              );
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  computed: {
    ...mapState({
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
      globalLoading: (state) => state.loading.globalLoading,
      periods: (state) => state.thaismartTax.timePeriodsList,
      taxWHBranch: (state) => state.thaismartTax.taxWHBranch,
      docsThaiSm: (state) => state.thaismartTax.docsThaiSm,
      docs: (state) => state.thaismartTax.list,
      //companyDetail:(state) =>state.companies.companyDetail,
      taxCodes: function (state) {
        if (this.selectedTaxType === "ภาษีขาย") {
          return state.thaismartTaxDetail.taxCodes?.filter(
            (i) => i.available === "S" && i.excludefromtaxreports === "F"
          );
        } else {
          return state.thaismartTaxDetail.taxCodes?.filter(
            (i) => i.available === "P" && i.excludefromtaxreports === "F"
          );
        }
      },
    }),

    hierarchicalPeriods() {
      const years = this.periods
        .filter((period) => period.type === "year")
        .sort((a, b) => {
          const yearA = parseInt(a.name.match(/\d+/)[0], 10);
          const yearB = parseInt(b.name.match(/\d+/)[0], 10);
          return yearB - yearA;
        });
      //console.log("🚀 ~ hierarchicalPeriods ~ years:", years)
      const quarters = this.periods.filter(
        (period) => period.type === "quarter"
      );
      const months = this.periods.filter((period) => period.type === "month");

      return years.flatMap((year) => [
        { ...year, level: 0 },
        ...quarters
          .filter((quarter) => quarter.parentIndex === year.id)
          .flatMap((quarter) => [
            { ...quarter, level: 1 },
            ...months
              .filter((month) => month.parentIndex === quarter.id)
              .map((month) => ({ ...month, level: 2 })),
          ]),
      ]);
    },
    totalDocsThaiSm() {
      return this.docsThaiSm.length;
    },
    countSheetAttach() {
      return Math.ceil(this.totalDocsThaiSm / this.attachSheetPage);
    },
  },
  watch: {
    selectedTaxType: function (newVal, oldVal) {
      this.selectedTaxCodes = [];
    },
  },
};
</script>

<style lang="css" scoped>
.span-w {
  width: 100px;
}

.table-container {
  padding: 1rem;
}

table {
  width: 100%;
  table-layout: fixed;
}

.tr-gray {
  background-color: hsla(0, 0%, 62%, 0.149);
}

.tr-gray-low {
  background-color: hsla(0, 0%, 79%, 0.094);
}

.bot-bg {
  background-color: #133265;
}

.kbank-bg {
  background-color: #00a94f;
}

.ktb-bg {
  background-color: #01a6e6;
}

.bcel-bg {
  background-color: #ec1c24;
}

.bbl-bg {
  background-color: #0065fe;
}

.scb-bg {
  background-color: #4e2a82;
}

.uob-bg {
  background-color: #05377b;
}

.iframe {
  overflow: hidden !important;
  height: 100% !important;
  width: 60% !important;
  position: absolute !important;
  left: 20% !important;
  right: 10% !important;
  top: 0 !important;
}

.detail-table {
  /* border: 2px solid red; */
  height: 60vh;
  overflow-y: auto;
  /* Scrollbar customization */
  /* scrollbar-width: 5px; */
}

/* For WebKit browsers (Chrome, Safari, etc.) */
.detail-table::-webkit-scrollbar {
  width: 3px;
}

.detail-table::-webkit-scrollbar-track {
  background: rgba(231, 231, 231, 0.5);
}

.detail-table::-webkit-scrollbar-thumb {
  background-color: rgb(133, 133, 133);
  border-radius: 20px;
  border: transparent;
}

.table-container table {
  width: 100%;
  margin-bottom: 2rem;
}

.table-container th {
  padding: 8px 5px;
  text-align: left;
  color: #fff;
}

/* Styling for table cells */
.table-container td {
  padding: 10px;
  height: 60px;
}

.small {
  font-size: 12px;
  padding: 6px 12px;
}

.bg-quarter {
  background-color: #b2dfdb;
}

@media (max-width: 600px) {
  .v-btn {
    flex-grow: 1;
    margin-bottom: 5px;
    justify-content: flex-start;
    min-width: 200px;
    max-width: 250px;
  }

  .small {
    font-size: inherit;
    padding: inherit;
  }
}
</style>
